import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const OcasionesPage = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const ocasionesPrincipales = [
    {
      id: 1,
      title: 'Amor y Aniversarios',
      description: 'Expresa tu amor con flores que hablan del corazón',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5f3f5c35-2c59-465d-4e09-c0cf93eee600/publicContain',
      path: '/ocasion/amor-aniversario',
      alt: 'Rosas rojas para aniversario Arequipa - Flores románticas delivery'
    },
    {
      id: 2,
      title: 'Flores Amarillas',
      description: 'Celebra la amistad con flores que iluminan',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/cd309af2-66cc-4721-cc51-72039ea2ab00/public',
      path: '/ocasion/flores-amarillas',
      alt: 'Girasoles y flores amarillas Arequipa - Flores de la amistad'
    },
    {
      id: 3,
      title: 'Día del Padre y Madre',
      description: 'Honra a quienes más amas con flores especiales',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0c6ec651-4d5b-41a1-7023-7d76371fd400/public',
      path: '/ocasion/dia-madre-padre',
      alt: 'Flores día de la madre Arequipa - Regalos para mamá y papá'
    },
    {
      id: 4,
      title: 'Cumpleaños',
      description: 'Sorprende con flores que celebran la vida',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2966eecc-e8a1-45fa-66f6-df9656ec7e00/publicContain',
      path: '/ocasion/cumpleanos',
      alt: 'Flores para cumpleaños Arequipa - Arreglos festivos delivery'
    }
  ];

  const ocasionesAdicionales = [
    {
      id: 5,
      title: 'Día de la Mujer',
      description: 'Celebra a las mujeres con arreglos hermosos',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/a786cc17-edfc-44f5-7190-d8b1a4e5ae00/publicContain',
      path: '/ocasion/dia-mujer',
      alt: 'Flores día de la mujer Arequipa - Arreglos 8 de marzo'
    },
    {
      id: 6,
      title: 'Graduación',
      description: 'Celebra los logros con flores hermosas',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/54aef800-701d-4185-5244-1ad2e1980900/public',
      path: '/ocasion/graduacion',
      alt: 'Flores para graduación Arequipa - Regalos graduación universitaria'
    },
    {
      id: 7,
      title: 'Agradecimiento',
      description: 'Expresa tu gratitud con un detalle floral',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/3c289914-6f7b-48bf-5f2f-456ab5303900/public',
      path: '/ocasion/amor-aniversario',
      alt: 'Flores de agradecimiento Arequipa - Detalles florales gracias'
    },
    {
      id: 8,
      title: 'Recuperación',
      description: 'Desea pronta recuperación con flores',
      image: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8728d7bc-6b77-49b4-7bbe-77f98df9f300/public',
      path: '/producto/arreglos',
      alt: 'Flores para enfermos Arequipa - Arreglos para desear mejora'
    }
  ];

  return (
    <div className="min-h-screen bg-pink-50 pt-16 md:pt-20">
      <SEO 
        title="Flores para Cada Ocasión en Arequipa"
        description="Flores para todas las ocasiones en Arequipa: cumpleaños, aniversarios, día de la madre, graduación, flores amarillas y más. Delivery express el mismo día. Compra flores frescas ahora."
        keywords="flores para cumpleaños arequipa, flores aniversario arequipa, flores día de la madre arequipa, flores amarillas arequipa, girasoles arequipa, flores graduación arequipa, rosas rojas arequipa, flores románticas arequipa, flores día del padre arequipa"
      />
      
      {/* Hero Section */}
      <section 
        className="py-20 px-4"
        style={{
          backgroundImage: 'url(https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e9bba638-d807-427f-bea3-a775809cad00/publicContain)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-pink-900 mb-6">
            Flores para Cada Ocasión
          </h1>
          <p className="text-xl md:text-2xl text-pink-800">
            Encuentra el arreglo perfecto para tu momento especial en Arequipa
          </p>
        </div>
      </section>

      {/* Perfectos para Cada Ocasión */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-pink-900 mb-4">
            Perfectos para Cada Ocasión
          </h2>
          <p className="text-center text-pink-700 text-lg mb-12">
            Click en cada ocasión para ver productos especiales y hacer tu pedido
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {ocasionesPrincipales.map((ocasion) => (
              <div 
                key={ocasion.id}
                onClick={() => handleNavigation(ocasion.path)}
                className="group overflow-hidden bg-pink-50 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img 
                    src={ocasion.image}
                    alt={ocasion.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-pink-900/80 via-pink-900/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold mb-2">{ocasion.title}</h3>
                    <p className="text-sm text-pink-100">{ocasion.description}</p>
                    <p className="text-xs text-pink-200 mt-2">Ver más →</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Más Ocasiones Especiales */}
      <section className="py-16 px-4 bg-pink-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-pink-900 mb-4">
            Más Ocasiones Especiales
          </h2>
          <p className="text-center text-pink-700 text-lg mb-12">
            Encuentra flores para cualquier momento importante
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {ocasionesAdicionales.map((ocasion) => (
              <div 
                key={ocasion.id}
                onClick={() => handleNavigation(ocasion.path)}
                className="group overflow-hidden bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img 
                    src={ocasion.image}
                    alt={ocasion.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-pink-900/80 via-pink-900/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold mb-2">{ocasion.title}</h3>
                    <p className="text-sm text-pink-100">{ocasion.description}</p>
                    <p className="text-xs text-pink-200 mt-2">Ver detalles →</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-pink-900 mb-6">
            ¿Tienes una ocasión especial?
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Dinos qué necesitas y crearemos algo único para ti
          </p>
          <button
            onClick={() => window.open('https://wa.me/51959389799?text=Hola,%20necesito%20flores%20para%20una%20ocasión%20especial', '_blank')}
            className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-2"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
            Consultar Ahora
          </button>
        </div>
      </section>
    </div>
  );
};

export default OcasionesPage;